export default __webpack_public_path__ + "static/media/logo-inter.bdbe50d1.png";